import {takeLatest} from 'redux-saga/effects';
import {licenseTypes} from '.';
import loginTypes from '../../features/login/redux/types';
import actions from './actions';

// get license once user logged in
export function* licenseSaga() {
   yield takeLatest([licenseTypes.GET_LICENSE.SAGA, loginTypes.LOGIN.SUCCESS], actions.getLicense);
   yield takeLatest(licenseTypes.GET_LICENSE.SUCCESS, actions.getLicenseOptions);
   // yield takeLatest(types.GET_LICENSE.ERROR, getLicenseSaga);
}
